<template>

  <div class="shared-buyer-form">
    <!-- Buyer Type Toggle -->
    <buyer-type-toggle
      :value="buyerType"
      @input="$emit('update:buyerType', $event)"
    />

    <div class="buyer-form-wrapper mt-3">
      <template v-if="buyerType === 'INDIVIDUAL'">
        <div class="form-grid">
          <shared-field
            v-for="field in individualPrimaryFields"
            :key="field.key"
            :field-key="field.key"
            :label="field.label"
            :required="field.required"
            :placeholder="field.placeholder"
            :type="field.type"
            :field-state="fieldStates[field.key]"
            :override="overrides[field.key]"
            :allow-clear="!field.required"
            :error="fieldErrors[field.key]"
            :touched="isFieldTouched(field.key)"
            @update="onFieldUpdate(field.key, $event)"
            @undo="onFieldUndo(field.key)"
            @blur="onFieldBlur(field.key)"
          />
           <shared-field
            v-for="field in individualSecondaryFields"
            :key="field.key"
            :field-key="field.key"
            :label="field.label"
            :required="field.required"
            :placeholder="field.placeholder"
            :type="field.type"
            :field-state="fieldStates[field.key]"
            :override="overrides[field.key]"
            :allow-clear="!field.required"
            :error="fieldErrors[field.key]"
            :touched="isFieldTouched(field.key)"
            @update="onFieldUpdate(field.key, $event)"
            @undo="onFieldUndo(field.key)"
            @blur="onFieldBlur(field.key)"
          />
        </div>
      </template>

      <template v-if="buyerType === 'ENTERPRISE'">
        <div class="form-grid">
          <shared-field
            v-for="field in enterprisePrimaryFields"
            :key="field.key"
            :field-key="field.key"
            :label="field.label"
            :required="field.required"
            :placeholder="field.placeholder"
            :type="field.type"
            :field-state="fieldStates[field.key]"
            :override="overrides[field.key]"
            :allow-clear="!field.required"
            :has-search="field.key === 'buyerTaxCode'"
            :is-loading="field.key === 'buyerTaxCode' && lookupLoading"
            :error="fieldErrors[field.key]"
            :touched="isFieldTouched(field.key)"
            @search="onTaxCodeSearch"
            @update="onFieldUpdate(field.key, $event)"
            @undo="onFieldUndo(field.key)"
            @blur="onFieldBlur(field.key)"
          />
          <shared-field
            v-for="field in enterpriseSecondaryFields"
            :key="field.key"
            :field-key="field.key"
            :label="field.label"
            :required="field.required"
            :placeholder="field.placeholder"
            :type="field.type"
            :field-state="fieldStates[field.key]"
            :override="overrides[field.key]"
            :allow-clear="!field.required"
            :error="fieldErrors[field.key]"
            :touched="isFieldTouched(field.key)"
            @update="onFieldUpdate(field.key, $event)"
            @undo="onFieldUndo(field.key)"
            @blur="onFieldBlur(field.key)"
          />
        </div>

        <!-- <div class="form-grid form-grid--secondary">
          <shared-field
            v-for="field in enterpriseSecondaryFields"
            :key="field.key"
            :field-key="field.key"
            :label="field.label"
            :required="field.required"
            :placeholder="field.placeholder"
            :type="field.type"
            :field-state="fieldStates[field.key]"
            :override="overrides[field.key]"
            :allow-clear="!field.required"
            :error="fieldErrors[field.key]"
            :touched="isFieldTouched(field.key)"
            @update="onFieldUpdate(field.key, $event)"
            @undo="onFieldUndo(field.key)"
            @blur="onFieldBlur(field.key)"
          />
        </div> -->

      </template>
    </div>

  </div>

</template>

<script>
  import { FIELD_ACTION } from '@/view/pages/einvoice/utils/bulkBuyer.utils'
  import {
    EINVOICE_BUYER_TYPE,
    BUYER_VALIDATION,
    BUYER_VALIDATION_MESSAGES,
    isValidEmailList,
  } from '@/utils/einvoice.enum'
  import BuyerTypeToggle from './BuyerTypeToggle.vue'
  import SharedField from './SharedField.vue'

  export default {
    name: 'SharedBuyerForm',

    components: {
      BuyerTypeToggle,
      SharedField,
    },

    props: {
      buyerType: {
        type: String,
        required: true,
        validator: (v) => Object.values(EINVOICE_BUYER_TYPE).includes(v),
      },
      fieldStates: {
        type: Object,
        required: true,
      },
      overrides: {
        type: Object,
        required: true,
      },
      isWholesale: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        lookupLoading: false,
        currentSearchTaxCode: '',
        touchedFields: {}, // Track which fields have been touched

        // ─── Field Definitions ───────────────────────────────────
        individualPrimaryFields: [
          {
            key: 'buyerName',
            label: 'Họ tên người mua',
            required: true,
            placeholder: 'Nguyễn Văn A',
            type: 'text',
          },
        ],

        enterprisePrimaryFields: [
          {
            key: 'buyerTaxCode',
            label: 'Mã số thuế',
            required: true,
            placeholder: '0312345678',
            type: 'text',
          },
          {
            key: 'buyerName',
            label: 'Tên đơn vị',
            required: true,
            placeholder: 'Công ty TNHH ABC',
            type: 'text',
          },
          {
            key: 'buyerAddress',
            label: 'Địa chỉ',
            required: true,
            placeholder: 'Địa chỉ theo đăng ký kinh doanh',
            type: 'text',
          },
          {
            key: 'buyerEmail',
            label: 'Email nhận hóa đơn (nhiều email cách nhau dấu phẩy)',
            required: true,
            placeholder: 'ketoan@abc.com, giamdoc@abc.com',
            type: 'text',
          },
        ],
        enterpriseSecondaryFields: [
          {
            key: 'buyerContactPerson',
            label: 'Người mua hàng',
            required: false,
            placeholder: 'Tên người đại diện',
            type: 'text',
          },
          {
            key: 'buyerPhone',
            label: 'Số điện thoại',
            required: false,
            placeholder: '0901234567',
            type: 'tel',
          },
        ],
      }
    },

    computed: {
      individualSecondaryFields() {
        return [
          {
            key: 'buyerIdNumber',
            label: 'Số CCCD/CMND',
            required: false,
            placeholder: '012345678901',
            type: 'text',
          },
          {
            key: 'buyerTaxCode',
            label: 'MST cá nhân',
            required: false,
            placeholder: '(nếu có)',
            type: 'text',
          },
          {
            key: 'buyerAddress',
            label: 'Địa chỉ',
            required: this.isWholesale,
            placeholder: this.isWholesale ? 'Địa chỉ (bắt buộc với bán buôn)' : 'Địa chỉ (không bắt buộc)',
            type: 'text',
          },
          {
            key: 'buyerEmail',
            label: 'Email nhận hóa đơn (nhiều email cách nhau dấu phẩy)',
            required: false,
            placeholder: 'email1@example.com, email2@example.com',
            type: 'text',
          },
          {
            key: 'buyerPhone',
            label: 'Số điện thoại',
            required: false,
            placeholder: '0901234567',
            type: 'tel',
          },
        ]
      },

      /**
       * Get current fields based on buyer type
       */
      currentFields() {
        if (this.buyerType === EINVOICE_BUYER_TYPE.ENTERPRISE) {
          return [...this.enterprisePrimaryFields, ...this.enterpriseSecondaryFields]
        }
        return [...this.individualPrimaryFields, ...this.individualSecondaryFields]
      },

      /**
       * Compute validation errors for all fields
       */
      fieldErrors() {
        const errors = {}
        const fields = this.currentFields

        fields.forEach((field) => {
          const value = this.getFieldValue(field.key)
          const normalizedValue = (value || '').trim()

          if (field.required && !normalizedValue) {
            errors[field.key] = 'Trường này là bắt buộc'
            return
          }

          if (!normalizedValue) {
            return
          }

          // Cho phép nhiều email cách nhau dấu phẩy — kiểm tra từng email
          if (field.key === 'buyerEmail' && !isValidEmailList(normalizedValue)) {
            errors[field.key] = BUYER_VALIDATION_MESSAGES.format.customerEmail
            return
          }

          if (field.key === 'buyerPhone' && !BUYER_VALIDATION.PHONE_VN.test(normalizedValue)) {
            errors[field.key] = BUYER_VALIDATION_MESSAGES.format.customerPhone
            return
          }

          if (field.key === 'buyerTaxCode' && !BUYER_VALIDATION.TAX_CODE.test(normalizedValue)) {
            errors[field.key] = BUYER_VALIDATION_MESSAGES.format.customerTaxCode
            return
          }

          if (field.key === 'buyerIdNumber' && !BUYER_VALIDATION.ID_NUMBER.test(normalizedValue)) {
            errors[field.key] = BUYER_VALIDATION_MESSAGES.format.customerIdNumber
          }
        })

        return errors
      },

      /**
       * Check if form is valid
       */
      isValid() {
        return Object.keys(this.fieldErrors).length === 0
      },
    },

    watch: {
      isValid: {
        immediate: true,
        handler(valid) {
          this.$emit('validation', { valid, errors: this.fieldErrors })
        },
      },
      fieldErrors: {
        deep: true,
        handler(errors) {
          this.$emit('validation', { valid: this.isValid, errors })
        },
      },
    },

    methods: {
      /**
       * Get current value for a field (from override or fieldState)
       */
      getFieldValue(fieldKey) {
        const override = this.overrides[fieldKey]
        if (override?.action === FIELD_ACTION.CLEAR) {
          return ''
        }
        if (override?.action === FIELD_ACTION.OVERRIDE) {
          return override.value || ''
        }
        const state = this.fieldStates[fieldKey]
        if (state?.isMixed) {
          return '' // Mixed state means no uniform value
        }
        return state?.uniformValue || ''
      },

      /**
       * Mark a field as touched
       */
      onFieldBlur(fieldKey) {
        this.$set(this.touchedFields, fieldKey, true)
      },

      /**
       * Check if a field has been touched
       */
      isFieldTouched(fieldKey) {
        return !!this.touchedFields[fieldKey]
      },

      /**
       * Touch all fields (for submit validation)
       */
      touchAllFields() {
        this.currentFields.forEach((field) => {
          this.$set(this.touchedFields, field.key, true)
        })
      },

      /**
       * Validate form and return result
       */
      validate() {
        this.touchAllFields()
        return {
          valid: this.isValid,
          errors: this.fieldErrors,
        }
      },

      onFieldUpdate(fieldKey, override) {
        const updated = { ...this.overrides, [fieldKey]: override }
        this.$emit('update:overrides', updated)
        // Mark field as touched when user types
        this.$set(this.touchedFields, fieldKey, true)
      },

      onFieldUndo(fieldKey) {
        const updated = {
          ...this.overrides,
          [fieldKey]: { action: FIELD_ACTION.KEEP },
        }
        this.$emit('update:overrides', updated)
      },

      async onTaxCodeSearch(taxCode) {
        if (!taxCode) return
        this.lookupLoading = true
        this.currentSearchTaxCode = taxCode
        try {
          const http = this.$http || this.axios || window.axios
          if (!http) {
            console.error('HTTP client not found')
            return
          }

          const normalizedTaxCode = (taxCode || '').trim()
          const res = await http.get('v1/einvoice/companies', {
            params: { taxCode: normalizedTaxCode },
          })
          // Response format:
          // - Found: { data: { taxCode, name, shortName, address, status } }
          // - Not found: { data: null }
          const company = res.data?.data

          if (!company) {
            this.$bvToast.toast('Không tìm thấy thông tin doanh nghiệp với mã số thuế này.', {
              title: 'Tra cứu thất bại',
              variant: 'warning',
              solid: true,
              autoHideDelay: 3000,
            })
            return
          }

          // Found company -> Apply directly
          this.applyCompanyData(company)
        } catch (e) {
          console.error('Tax lookup error:', e)
          this.$bvToast.toast('Đã xảy ra lỗi hệ thống khi tra cứu thông tin.', {
            title: 'Lỗi',
            variant: 'danger',
            solid: true,
            autoHideDelay: 3000,
          })
        } finally {
          this.lookupLoading = false
        }
      },

      applyCompanyData(company) {
        const newOverrides = { ...this.overrides }

        const setField = (key, value) => {
          newOverrides[key] = { action: FIELD_ACTION.OVERRIDE, value }
        }

        // Response format: { taxCode, name, shortName, address, status }
        setField('buyerTaxCode', company.taxCode || this.currentSearchTaxCode)
        setField('buyerName', company.name || '')
        if (company.address) setField('buyerAddress', company.address)

        this.$emit('update:overrides', newOverrides)

        this.$bvToast.toast(`Đã áp dụng: ${company.name}`, {
          title: 'Tra cứu thành công',
          variant: 'success',
          solid: true,
          autoHideDelay: 2000,
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  $primary: #3699ff;
$primary-light: #e1f0ff;
$primary-dark: #2b7de9;
$neutral-50: #fafbfc;
$neutral-100: #f4f5f7;
$neutral-200: #e5e7eb;
$neutral-300: #d1d5db;
$neutral-500: #6b7280;
$neutral-700: #374151;
$neutral-900: #111827;
$warning-bg: #fff9ed;
$warning-text: #92400e;
$radius-sm: 6px;
$radius-md: 10px;

.shared-buyer-form {
  .buyer-form-wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem 1rem;

    .shared-field-wrapper {
      margin-bottom: 0;
    }

    &--secondary {
      margin-top: 0.25rem;
      padding-top: 1rem;
      border-top: 1px solid $neutral-200;
    }
  }

  .skip-invoice-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 0.625rem 0.875rem;
    background: $neutral-50;
    border: 1px solid $neutral-200;
    border-radius: $radius-md;
    transition: background-color 0.2s ease, border-color 0.2s ease;

    &:hover {
      background: $neutral-100;
    }

    small {
      color: $neutral-500;
      font-size: 0.8125rem;
      letter-spacing: -0.01em;
    }
  }

  .skip-invoice-notice {
    display: flex;
    align-items: flex-start;
    gap: 0.625rem;
    padding: 0.875rem 1rem;
    background: $warning-bg;
    border: 1px solid #fde68a;
    border-radius: $radius-md;
    color: $warning-text;
    font-size: 0.8125rem;
    letter-spacing: -0.01em;
    line-height: 1.5;

    i {
      font-size: 1.125rem;
      flex-shrink: 0;
      margin-top: 0.0625rem;
    }
  }

  .foreign-buyer-info {
    display: flex;
    align-items: flex-start;
    gap: 0.625rem;
    padding: 0.875rem 1rem;
    background: $primary-light;
    border: 1px solid rgba($primary, 0.15);
    border-radius: $radius-md;
    font-size: 0.8125rem;
    color: $primary-dark;
    letter-spacing: -0.01em;
    line-height: 1.5;

    i {
      flex-shrink: 0;
      margin-top: 0.0625rem;
      font-size: 1rem;
    }
  }
}

@media (max-width: 768px) {
  .shared-buyer-form {
    .form-grid {
      grid-template-columns: 1fr;
      gap: 0;

      &--secondary {
        margin-top: 0.75rem;
        padding-top: 0.75rem;
      }
    }
  }
}
</style>
